import MicroModal from "micromodal";

/**
 *
 * Get the parameter from the URL by name
 *
 * @param string name - URL parameter name
 * @param string url - URL
 */
export function getParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 *
 * Scroll to element on a page
 *
 * @param string element - id of the element to scroll to
 */
export function scrollPageTo(element) {
	// Figure out element to scroll to
	if (validateCssSelector(element)) {
		var target = $(element);

		target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

		// Does a scroll target exist?
		if (target.length) {
			var scrollTo = target.offset().top - 10;
			//windowSize = $(window).width(),
			// navbarHeight = $("#js-main-nav").height();

			//added the height of the navbar if not mobile
			// if (windowSize > 984) {
			//   scrollTo = scrollTo - navbarHeight;
			// }

			$("html, body").animate(
				{
					scrollTop: scrollTo,
				},
				1000,
				function () {
					// Callback after animation
					// Must change focus!
					var $target = $(target);

					$target.focus();

					if ($target.is(":focus")) {
						// Checking if the target was focused
						return false;
					} else {
						$target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					}
				}
			);
		}
	}
}

/**
 * OPEN .PDF'S AND EXTERNAL LINKS IN A NEW WINDOW
 * ADD js-external-link CLASS
 */
export function buildExternal() {
	$('a[href^="http:"], a[href^="https:"]')
		.not(
			'[href*="https://myaccountable-now.com"], [href*="virginia529.com"], [href*="ww2.payerexpress.com"], [href*="https://vcc-na20b.8x8.com"], [href*="https://www.pnc.com"], [href*="' +
				document.domain +
				'"], .no-warning'
		)
		// .attr("target", "_blank")
		.addClass("js-external-link");
	$('a[href$=".pdf"]').attr("target", "_blank");

	externalLink();
}

export function getTemplate(url, listContainer, btnContainer) {
	const loadBtnEl = document.getElementById(btnContainer),
		listContainerEl = document.getElementById(listContainer);

	loadBtnEl.innerHTML = '<div class="loading"></div>';

	fetch(url, {
		method: "GET",
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
	})
		.then((response) => {
			return response.text();
		})
		.then((text) => {
			loadBtnEl.style.display = "none";
			listContainerEl.innerHTML += text;
		})
		.catch((error) => {
			console.log("Error:", error);
		});

	// $.get(url, function(data) {
	//   $loadBtn.hide();
	//   $listContainer.append(data);
	// });
}

/**
 *
 * @param {JSON} data JSON to be validated
 *
 * @return {Boolean} Returns True if valid JSON
 */
export function isValidJSON(data) {
	if (typeof data === "object") {
		return true;
	} else {
		return false;
	}
}

/**
 * Get current hostname
 *
 * @return {string} current hostname
 */
export function getHostname() {
	return window.location.protocol + "//" + window.location.host;
}

/**
 * Show Loading SVG
 *
 * @return {string} HTML string for loading graphic
 */
export function showLoading() {
	return '<span class="loading"></span>';
}

/**
 * Display Search Modal
 */

export function showSearchModal(searchBtn) {
	$(searchBtn).on("click", function (e) {
		e.preventDefault();

		MicroModal.show("search-modal", {
			disableScroll: true,
		});
	});
}

/**
 * Basic check to see if css selector is vaild
 *
 * @param {String} str css selector to be tested
 *
 * @return {Boolean}
 */
export function validateCssSelector(str) {
	try {
		document.querySelector(str);
		return true;
	} catch (e) {
		return false;
	}
}

/**
 * Debounce
 */
export function debounce(func, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(function () {
			func.apply(this, args);
		}, timeout);
	};
}

/**
 * Check if leaving site
 */
function externalLink() {
	$(".js-external-link").on("click", function (e) {
		e.preventDefault();

		let externalLinkURL = $(this).attr("href");

		MicroModal.show("js-external-modal", {
			disableScroll: true,
			onShow: function () {
				$("#js-external-link").attr("href", externalLinkURL);
			},
		});
	});
}
